import { Injectable } from "@angular/core";

import {QueryStringSerializationService} from "../../shared-library/services/environment/query-string-serialization.service";

@Injectable({
  providedIn: "root"
})
export class SlimQueryStringSerializationService extends QueryStringSerializationService {
    public slimSerialize(data: any, defaultData: any): string {
        const slimData = this.removeDuplicates(data, defaultData);
        return this.serialize(slimData);
    }

    private removeDuplicates(a: any, defaults: any): any {
        const result = {};
        for (const i in a) {
            if (i in defaults) {
                if (typeof a[i] === "object"
                    && typeof defaults[i] === "object"
                    && Object.prototype.toString.call(defaults[i]) !== "[object Array]") {
                    result[i] = this.removeDuplicates(a[i], defaults[i]);
                } else if (a[i] !== defaults[i]) {
                    result[i] = a[i];
                }
            } else {
                result[i] = a[i];
            }
        }

        return result;
    }
}
